import { Video, EnrichedVideo } from '@/lib/api/client'

export const generateThumbnails = async (
  videos: Array<Video>,
  seekToSeconds: number,
) => {
  if (!videos) return []
  const results: EnrichedVideo[] = await Promise.all(
    videos
      .filter((video) => video.download_url)
      .map((videoObject) => {
        return new Promise<EnrichedVideo>((resolve) => {
          const video = document.createElement('video')
          video.crossOrigin = 'anonymous'
          video.src = videoObject.download_url as string
          video.muted = true
          video.preload = 'auto'
          video.playsInline = true

          const cleanup = () => {
            video.remove()
          }

          video.addEventListener('loadedmetadata', () => {
            const seekTime = Math.min(seekToSeconds, video.duration - 0.1)
            video.currentTime = seekTime > 0 ? seekTime : 0
          })

          video.addEventListener('seeked', () => {
            try {
              const canvas = document.createElement('canvas')
              canvas.width = video.videoWidth
              canvas.height = video.videoHeight
              const ctx = canvas.getContext('2d')

              if (ctx) {
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
                const dataURL = canvas.toDataURL('image/png')
                cleanup()
                resolve({
                  ...videoObject,
                  thumbnail: dataURL,
                })
              } else {
                cleanup()
                resolve(videoObject)
              }
            } catch (err) {
              console.warn(
                `Thumbnail generation failed for ${videoObject.download_url}`,
                err,
              )
              cleanup()
              resolve(videoObject)
            }
          })

          video.addEventListener('error', () => {
            cleanup()
            resolve(videoObject)
          })
        })
      }),
  )

  return results
}
